import React, { useState, useEffect, useRef } from "react";
import Typography from "@mui/material/Typography";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import styles from "./CustomNode.module.css";

export const CustomNode = (props) => {

    const indent = props.depth * 10;

    const handleToggle = (e) => {
        e.stopPropagation();
        props.onToggle(props.node.id);
    };

    const handleSelect = () => props.onSelect(props.node);
    const handleDelete = () => props.onDelete(props.node)

    // actions: 0 = show video, 1 = edit exercise, 2 = copy exercise, 3 = paste exercise

    const handleContextMenuShowVideoClick = () => {
        closeContextMenu()
        props.onContextMenuClick(props.node, 0)
    }

    const handleContextMenuEditItemClick = () => {
        closeContextMenu()
        props.onContextMenuClick(props.node, 1)
    }

    const handleContextMenuCopyItemClick = () => {
        closeContextMenu()
        props.onContextMenuClick(props.node, 2)
    }

    const handleContextMenuPasteItemClick = () => {
        closeContextMenu()
        props.onContextMenuClick(props.node, 3)
    }

    // right click / long press handling

    const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
    const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 });
    const [selectedItem, setSelectedItem] = useState(null);
    const contextMenuRef = useRef(null);


    let touchTimeout;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
                closeContextMenu();
            }
        };

        window.addEventListener('click', handleClickOutside);
        return () => {
            window.removeEventListener('click', handleClickOutside);
            clearTimeout(touchTimeout);
        };
    }, [touchTimeout]);

    const handleContextMenu = (event) => {
        event.preventDefault();
        if (props.node.droppable && !props.showEditMenu) return // prevent menu from opening if it is not an exercise node eligible for paste
        setIsContextMenuOpen(true);
        setContextMenuPosition({ x: event.clientX, y: event.clientY });
        setSelectedItem(props.node);
    };

    const handleTouchStart = (event) => {
        if (props.node.droppable && !props.showEditMenu) return // prevent menu from opening if it is not an exercise node and not eligible for paste
        touchTimeout = setTimeout(() => {
            event.preventDefault();
            setIsContextMenuOpen(true);
            setContextMenuPosition({ x: event.touches[0].clientX, y: event.touches[0].clientY });
            setSelectedItem(props.node);
        }, 500);
    };

    const handleTouchMove = () => {
        clearTimeout(touchTimeout);
    };

    const handleTouchEnd = () => {
        clearTimeout(touchTimeout);
    };

    const closeContextMenu = () => {
        setIsContextMenuOpen(false);
        setSelectedItem(null);
    };

    return (
        <div
            className={`tree-node ${styles.root} ${props.isSelected ? styles.isSelected : ""
                }`}
            style={{ paddingInlineStart: indent }}
            onClick={handleSelect}
            onContextMenu={(event) => handleContextMenu(event)}
            onTouchStart={(event) => handleTouchStart(event)}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            <div>
                {props.node.droppable && props.node.id !== 1969 && (
                    <div onClick={handleToggle}>
                        {props.isOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                    </div>
                )}
            </div>


            <Typography variant="body2" color={props.node.id === 1969 ? 'gray' : 'currentcolor'} >{props.node.text}</Typography>


            <div className={styles.labelGridItem}>
                <div className={styles.inputWrapper}>
                    {(props.visibleDelete && props.node.id !== 1969) ? ( // to hide the delete icon when the node is a root node  && props.node.parent
                        <IconButton className={styles.editButton} color="error" onClick={handleDelete}>
                            <CloseIcon className={styles.editIcon} />
                        </IconButton>
                    ) : <div />}
                </div>
            </div>
            {isContextMenuOpen && selectedItem && (
                <div
                    ref={contextMenuRef}
                    className="node-context-menu"
                    style={{
                        top: contextMenuPosition.y,
                        left: contextMenuPosition.x,
                        position: 'absolute',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #ced4da',
                        padding: '4px',
                        fontSize: '14px',
                        textAlign: 'left',
                        color: 'black',
                        zIndex: 9999,
                        borderRadius: '8px'
                    }}
                >
                    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                        {!props.node.droppable && // show only for leaf nodes (i.e. exercises)
                            <li
                                onClick={handleContextMenuShowVideoClick}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                Vis øvelse {selectedItem.name}
                            </li>
                        }
                        {props.node.droppable && props.showEditMenu  && // show only on programs and where one can paste an exercise
                            <li
                                onClick={handleContextMenuPasteItemClick}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                Lim inn {selectedItem.name}
                            </li>
                        }
                        {!props.node.droppable && props.showEditMenu && // show only for user program and program admin exercises
                            <div>
                                <li
                                    onClick={handleContextMenuEditItemClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s',
                                    }}
                                >
                                    Rediger {selectedItem.name}
                                </li>
                                <li
                                    onClick={handleContextMenuCopyItemClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s',
                                    }}
                                >
                                    Kopier {selectedItem.name}
                                </li>
                            </div>
                        }
                    </ul>
                </div>
            )}
        </div>
    );
};
